import { $, $$ } from 'utils/dom';
import Lightbox from 'modules/lightbox/Lightbox';
import Swiperslider from 'modules/swiper/swiper';

const setSlidesWidth = slides => {
  slides.forEach(slide => {
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;

    if (viewportWidth < 768) {
      const widthMobile = parseInt(slide.getAttribute('data-width-mobile'));
      slide.style.width = `${widthMobile}px`;
    }
    if (viewportWidth > 767) {
      const widthTablet = parseInt(slide.getAttribute('data-width-tablet'));
      slide.style.width = `${widthTablet}px`;
    }
    if (viewportWidth > 1199) {
      const widthDesktop = parseInt(slide.getAttribute('data-width-desktop'));
      slide.style.width = `${widthDesktop}px`;
    }
  });
};

const imageGallery = $$('.image-gallery');

if (imageGallery.length) {
  const slides = $$('.image-gallery__item');

  if (slides.length) {
    setSlidesWidth(slides);
  }

  imageGallery.forEach(gallery => {
    new Lightbox(gallery, {
      selector: '.lightbox-toggle',
    }).init();

    const slider = new Swiperslider(
      $('.image-gallery__item-wrapper', gallery),
      {
        container: gallery,
        sliderOptions: {
          spaceBetween: 30,
        },
      }
    );
    slider.init();
  });
}
